import { useCallback, useState } from "react";
import { Button, useNotify, useRefresh } from "react-admin";
import {
  Card,
  Dialog,
  DialogTitle,
  Divider,
  Button as MuiButton,
} from "@material-ui/core";
import { ChangeSelectedEventsShippingDocsForm } from "./ChangeSelectedEventsShippingDocsForm";
import { AssignmentOutlined } from "@material-ui/icons";

interface Props {
  selectedRows: number[];
  currentShippingDocs?: Array<string | null | undefined>;
  latestEvent?: number;
  shouldRenderReactAdminButton?: boolean;
}

export const ChangeEventsShippingDocs = ({
  selectedRows,
  currentShippingDocs,
  latestEvent,
  shouldRenderReactAdminButton = true,
}: Props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const handleFailed = useCallback(() => setDialogOpen(false), []);
  const handleSuccess = useCallback(() => {
    setDialogOpen(false);
    notify(
      "resources.hos-driver-log-view.messages.changeEventsShippingDocsSuccess",
      {
        type: "success",
      }
    );
    refresh();
  }, [refresh, notify]);

  return (
    <>
      {shouldRenderReactAdminButton ? (
        <Button
          className="master-action"
          label="Change shipping docs..."
          onClick={() => setDialogOpen(true)}
        >
          <AssignmentOutlined />
        </Button>
      ) : (
        <MuiButton
          color="primary"
          variant="text"
          onClick={() => setDialogOpen(true)}
          startIcon={<AssignmentOutlined />}
        >
          Change shipping docs
        </MuiButton>
      )}
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Change shipping docs for {selectedRows.length} event(s)
        </DialogTitle>
        <Divider />
        <Card>
          <ChangeSelectedEventsShippingDocsForm
            selectedRows={selectedRows}
            currentShippingDocs={currentShippingDocs}
            latestEvent={latestEvent}
            onSuccess={handleSuccess}
            onFailed={handleFailed}
          />
        </Card>
      </Dialog>
    </>
  );
};
